import profImageLight from '../../assets/images/landiscape-light.svg';

export default {
	title: 'light',
	colors: {
		background: '#fff',
		title: '#232423',
		subTitle: '#333',
		paragraphText: '#6a6180',
		subtext: '#5f5f5f',
		button: '#232423',
		buttonHover: '#464646',
		box: '#FBFBFB',
		input: '#F3F3F3',
		border: '#DADADA',
		primary: '#6ec987',
		lighter: '#298642'
	},
	landiscape: profImageLight
};
